import { createContext, useContext } from 'react';

/** Describes what the student is currently viewing inside the CourseLayout Outlet */
export interface ActiveLessonState {
  type: 'lesson' | 'quiz' | 'overview';
  title: string;
  chapterTitle?: string;
  /** Short text excerpt for tutor context (first ~200 chars of notes) */
  excerpt?: string;
  lessonId?: string;
  quizId?: string;
}

export interface ActiveLessonContextType {
  activeLesson: ActiveLessonState | null;
  setActiveLesson: (state: ActiveLessonState) => void;
  clearActiveLesson: () => void;
}

export const ActiveLessonContext = createContext<ActiveLessonContextType | undefined>(undefined);

/** Read the current active lesson/quiz context. Used by AiTutorPanel. */
export function useActiveLesson() {
  const context = useContext(ActiveLessonContext);
  if (context === undefined) {
    throw new Error('useActiveLesson must be used within an ActiveLessonProvider');
  }
  return context;
}

/** Set the active lesson context. Used by child routes (LessonViewer, QuizViewer). */
export function useSetActiveLesson() {
  const { setActiveLesson, clearActiveLesson } = useActiveLesson();
  return { setActiveLesson, clearActiveLesson };
}
